import React, { useState, useEffect } from 'react'
import Loader from '../../../../../presentationals/Loader/Loader.component'
import Popup from '../../../../../presentationals/Popup/Popup.component'
import Pagination from '@mui/material/Pagination';
import NodataImage from '../../../../../../images/nodata.png';
import { getNPAWeightageDateByParamId, DeleteNPAWeightageDateByUUId } from '../Actioncreator';

const itemsPerPage = 10;
export default function List({ Detaildata, handleType }) {
    const [loader, setLoader] = useState(false);
    const [showPopup, setShowPopup] = useState({ show: false, popupStatus: "" });
    const [tableData, settableData] = useState([])
    const [filtertableData, setfiltertableData] = useState([])
    const [currentPage, setcurrentPage] = useState(1)
    const [searchField, setsearchField] = useState("")


    useEffect(() => {
        ListingAPI(Detaildata)
    }, [])

    const ListingAPI = (data) => {
        setLoader(true)
        getNPAWeightageDateByParamId(data?.creditParamId, callback => {

            setLoader(false)
            console.log("call", callback)
            if (callback && callback?.status == 200 && callback?.data?.length > 0) {
                settableData(callback?.data)
                HandleDataFilter(currentPage, callback?.data)
            } else {
                settableData([])
                setfiltertableData([])
            }
        })
    }



    const HandleDataFilter = (page, totalData) => {
        const paginatedData = totalData && totalData?.length > 0 ? totalData.slice(
            (page - 1) * itemsPerPage,
            page * itemsPerPage
        ) : [];
        setfiltertableData(paginatedData)
    }

    const handleInput = (e) => {
        if (e.target.value?.length === 0) {
            // api call 
        }
        setsearchField(e.target.value)
    }

    const handleSearch = (e) => {
        if (searchField.trim().length === 0) {
            HandleDataFilter(1, tableData);
            setcurrentPage(1);
        } else {
            const filterData = tableData?.filter((el) =>
                el?.subparam?.toLowerCase().includes(searchField.toLowerCase())
            );

            setfiltertableData(filterData);
            setcurrentPage(1);
        }
    }


    const actionHandler = (type, data) => {
        if (type === "add") {
            handleType("addSubcategory", "")
        } else if (type === "delete") {
            setLoader(true)
            DeleteNPAWeightageDateByUUId(data?.uuid, callback => {
                setLoader(false)
                if (callback && callback?.message == "success" && callback?.status == 200) {
                    ListingAPI(Detaildata)
                    setShowPopup({ show: true, popupStatus: 'Data Deleted Successfully' })
                } else {
                    setShowPopup({ show: true, popupStatus: 'Error Deleting Data' })
                }
                removePopup()
            })

        } else if (type == "edit") {
            handleType("editSubcategory", data)
        }
    }

    const handlePageChange = (event, value) => {
        setcurrentPage(value)
        HandleDataFilter(value, tableData)

    }

    const closePopup = () => {
        setShowPopup({ show: false, popupStatus: '' })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }

    const getAddedDate = (dates) => {
        const d = new Date(dates);
        const year = d.getFullYear();
        const m = (d.getMonth() + 1).toString().padStart(2, "0");
        const date = (d.getDate()).toString().padStart(2, "0")
        return `${date}-${m}-${year}`
    }

    return (
        <>
            {loader ? <Loader /> : ''}
            {
                showPopup?.show ?
                    <Popup popupStatus={showPopup?.popupStatus} closePopup={closePopup} />
                    : ''}


            <div className="row" style={{ marginTop: '50px' }}>
                {/* {
                    Detaildata?.type === "TEXT" ? */}
                <div className="col-sm-2 col-xs-6">
                    <label htmlFor=""><i class="fa fa-search" aria-hidden="true"></i> Search</label>
                    <input placeholder='Sub category Name' id="customDateInput" className='form-control' onKeyDown={() => handleSearch()} value={searchField} onChange={(e) => handleInput(e)} />
                </div>
                {/* : ''} */}
                <div className="col-sm-1 col-xs-6" style={{ marginTop: '22px' }}>
                    <div className='btn-group' style={{ display: 'flex' }}>
                        <button
                            className='cred-btn center-block mr-3'
                            onClick={e => actionHandler('add', "")}
                            style={{ padding: '10px 15px', background: '#064254', borderRadius: '8px', border: '1px solid #064254' }}><i style={{ fontSize: '16px' }} className='fa fa-plus' /></button>


                    </div>
                </div>

                <div className="col-xs-12" style={{ marginTop: '30px' }}>
                    <div className='table-responsive full-height'>
                        {filtertableData?.length > 0 ?
                            <>
                                <div style={{ overflowX: 'auto' }}>
                                    <table className='table credhub-table'>
                                        <thead>

                                            {
                                                Detaildata?.type === "TEXT" || Detaildata?.type == "OEM" || Detaildata?.type == "DEALER" ?
                                                    <tr>
                                                        <th scope='col'>Sub-Category Name</th>
                                                        <th scope='col'>NPA</th>
                                                        <th scope='col'>Weightage</th>
                                                        <th scope='col'>Added On</th>
                                                        <th scope="col">Edit</th>
                                                    </tr>
                                                    : ''}
                                            {
                                                Detaildata?.type === "NUMERIC" ?
                                                    <tr>

                                                        <th scope='col'>Min Value</th>
                                                        <th scope='col'>Max Value</th>
                                                        <th scope='col'>Min Range</th>
                                                        <th scope='col'>Max Range</th>
                                                        <th scope='col'>NPA</th>
                                                        <th scope='col'>Weightage</th>
                                                        <th scope='col'>Vehicle Type</th>
                                                        <th scope='col'>Added On</th>
                                                        <th scope="col">Edit</th>

                                                    </tr>
                                                    : ''}

                                        </thead>
                                        <tbody>
                                            {
                                                Detaildata?.type === "TEXT" || Detaildata?.type == "OEM" || Detaildata?.type == "DEALER" ?

                                                    filtertableData?.map((row, i) => {
                                                        return (
                                                            <tr key={i}>


                                                                <td>{row?.subParam ?? "-"}</td>
                                                                <td>{row?.npa ?? "-"}</td>
                                                                <td>{row?.weightage ?? "-"}</td>
                                                                <td>{getAddedDate(row?.addedOn) ?? "-"}</td>
                                                                <td>
                                                                    <button className='btn action-btn' onClick={e => actionHandler('edit', row)}>
                                                                        <i class="fa fa-pencil-square-o" />
                                                                    </button>
                                                                    <button className='btn action-btn' onClick={e => actionHandler('delete', row)}>
                                                                        <i className='fa fa-trash-o' />
                                                                    </button>
                                                                </td>

                                                            </tr>
                                                        )
                                                    })
                                                    : ''}
                                            {
                                                Detaildata?.type === "NUMERIC" ?
                                                    filtertableData?.map((row, i) => {
                                                        return (
                                                            <tr key={i}>


                                                                <td>{row?.minValue ?? "-"}</td>
                                                                <td>{row?.maxValue ?? "-"}</td>
                                                                <td>{row?.minRange ?? "-"}</td>
                                                                <td>{row?.maxRange ?? "-"}</td>
                                                                <td>{row?.npa ?? "-"}</td>
                                                                <td>{row?.weightage ?? "-"}</td>
                                                                <td>{row?.vehicleType ?? "-"}</td>
                                                                <td>{getAddedDate(row?.addedOn) ?? "-"}</td>
                                                                <td>
                                                                    <button className='btn action-btn' onClick={e => actionHandler('edit', row)}>
                                                                    <i class="fa fa-pencil-square-o" />
                                                                </button>
                                                                    <button className='btn action-btn' onClick={e => actionHandler('delete', row)}>
                                                                        <i className='fa fa-trash-o' />
                                                                    </button>
                                                                </td>

                                                            </tr>
                                                        )
                                                    }) : ''}


                                        </tbody>
                                    </table>
                                </div>

                                <Pagination
                                    count={Math.ceil(tableData?.length / itemsPerPage)}
                                    page={currentPage}
                                    onChange={handlePageChange}
                                    color="success" variant="outlined" shape="rounded"
                                    style={{ display: 'flex', justifyContent: 'end' }}
                                />
                            </>
                            :
                            <p style={{ marginTop: '100px' }} className="text-center">
                                <img src={NodataImage} style={{ width: '30%' }} alt="No data available" />
                            </p>
                        }
                    </div>
                </div>

            </div>
        </>
    )
}
